module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAMlJREFUOI3VktsNwjAMRY86QTYgI2SEbEJH6AjdhG4AG5AN6AbtBrABfNRRjGgeiC+uZCmyro8tx/AuB5yABXhKnIEjX2hUxXtxA8w3kAnwkrfAADxaYE5B+ozHAqt4xhxoUpOU5MV3zxliJ18BFb0dcJB3aATtqlNv2wAq6sI27lDxGdKn7DbtSUss3UlsGErdZjEtfC7SsF13nMbVxp6VeQGuEvq6V8lVYSPpinUEKQ6kNRRhUV6FVXmnGjXDcvoPWPgFFGEBMC9rbFQpyLYvHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/media/tinySearch.png
// module id = 148
// module chunks = 0